'use strict';

var trackingUtils = require('../modules/utils/tracking.utils');

Odigeo.defineWidget('country_links', Odigeo.Widget.extend({
    modelClass: Odigeo.Model.extend({
        defaults: {
            continentItems: [],
            showArrow: false,
        },
        isEmptyData: false,
    }),

    viewClass: Odigeo.View.extend({
        selectors: {
            headerLauncher: '.header_launcher',
            closeButton: '.header_tooltip_close',
            countryLink: '.country_link',
            internationalLink: '.international_site_link',
            continentHeader: '.continent_header',
            continentContent: '.continent_content',

        },

        events: {
            'tap @countryLink': 'onCountryLinkClick',
            'tap @internationalLink': 'onInternationalLinkClick',
            'tap @closeButton': 'onClose',
            'tap @continentHeader': 'onAccordion',
            'tap @headerLauncher': 'onOpen',
        },

        init: function() {
            this.listenTo(this.widget.model, 'change', this.render);
        },

        render: function() {
            const countryLinks = document.querySelector('#country-links').dataset.countryselectorconfig;
            if (countryLinks) {
                const dataSet = JSON.parse(countryLinks);
                this.setTemplate(this.$el, 'countryLinks', JSON.stringify(dataSet));
                this.addDomSelectorsToCache();
            }
        },

        onOpen: function(e) {
            e.stopPropagation();
            var isOpened = this.$cachedSelectors.headerLauncher.hasClass('opened');
            if (!isOpened) {
                $('#header').find('.opened').removeClass('opened');
            }
            this.$cachedSelectors.headerLauncher.toggleClass('opened', !isOpened);
            this.$el.find('.continent_header.unfolded').trigger(Odigeo.Events.tap);
            trackingUtils.trackEvent('header', 'header_country', Odigeo.Utils.getTrackingCategory());
        },

        onAccordion: function(e) {
            var $continentsHeaders = this.$cachedSelectors.continentHeader;
            var $continentsContents = this.$cachedSelectors.continentContent;

            var $el = $(e.target);
            var $content;
            var contentHeight;
            var $contentCountries;

            $continentsHeaders.removeClass('unfolded');
            $continentsContents.height(0);
            $el.closest('.continent_header').addClass('unfolded');

            $content = $continentsHeaders.filter('.unfolded').find(' + .continent_content');
            $contentCountries = $content.find('.continent_countries');
            contentHeight = $contentCountries.height();
            $content.height(0 < contentHeight ? contentHeight : $($contentCountries.find('li')[0]).height());
        },

        onClose: function() {
            this.$cachedSelectors.headerLauncher.removeClass('opened');
        },

        onCountryLinkClick: function(e) {
            var countryLanguage = $(e.target).data('countryIcon');
            trackingUtils.trackEvent('header', 'header_country_' + countryLanguage, Odigeo.Utils.getTrackingCategory());
        },

        onInternationalLinkClick: function() {
            trackingUtils.trackEvent('header', 'language_international', Odigeo.History.getPageNameFromFragment());
        },

        beforeInsertTemplate: function(data) {
            const currentNation = this.$el.data('websitecode');
            const currentLang = this.$el.data('websitelang').substring(0, 2);
            let icon = 'global';
            const model = JSON.parse(document.querySelector('#country-links').dataset.countryselectorconfig) || data || this.model.toJSON();
            const isCatalanEnabled = Odigeo.AB.isCatalanEnabled;
            model.continentItems = _.chain(model.continentItems)
                .each(function(continent) {
                    let numCountries;
                    let mod;
                    continent.className = '';
                    continent.countryDTOs = _.chain(continent.countryDTOs)
                        .each(function(country) {
                            if (Array.isArray(country.countryDTOs)) {
                                country.countryDTOs = country.countryDTOs.filter(function(lang) {
                                    return !(!isCatalanEnabled && (lang.id === 'ES_ca' || lang.id === 'OPES_ca'));
                                });
                            }
                        })
                        .reject({icon: 'GLOBAL'})
                        .each(function(country, index) {
                            if (country.id === currentNation || continent.id === 'global') {
                                continent.className = 'unfolded';
                            }
                            if (country.id === currentNation) {
                                icon = country.icon ||
                                    (((country.countryDTOs || []).find((c) => c.id.split('_')[1] === currentLang) || {}).icon) ||
                                    'global';
                            }
                            country.hasLanguages = !!country.countryDTOs;
                            country.className = country.hasLanguages ? ' od-country-with-languages' : '';
                            country.className += index >= continent.indexLastLine ? ' od-country-last-row' : '';
                        })
                        .value();

                    numCountries = continent.countryDTOs.length;
                    mod = (numCountries % 3) || 3;
                    continent.indexLastLine = numCountries - mod;
                })
                .value();
            const lastContinent = _.last(model.continentItems);
            if (lastContinent) {
                lastContinent.className += ' od-header-last-continent';
            }
            model.language = currentLang.toUpperCase();
            model.nation = 2 < currentNation.length ? currentNation.substring(2, 4) : currentNation;
            model.icon = icon.toLowerCase();

            return {
                model: model,
                cms: this.keys || {},
            };
        },

    }),
}));
